export const createElement = (tagName, { className, dataset, text } = {}) => {
  const element = document.createElement(tagName)

  if (className) { element.className = className }
  if (text !== undefined) { element.textContent = text }

  Object.entries(dataset || {}).forEach(([name, value]) => {
    element.dataset[name] = value
  })

  return element
}

export const createFormGroup = (label, control) => {
  const group = createElement("div", { className: "form-group" })
  group.append(createElement("label", { text: label }), document.createElement("br"), control)

  return group
}

export const createApplyButton = (label) => {
  const button = createElement("button", {
    className: "btn btn-primary",
    dataset: { filterSelectionAdd: "" },
    text: label,
  })
  button.type = "button"

  return button
}

export const createSelect = (options, { className = "form-control", multiple = false } = {}) => {
  const select = createElement("select", { className })
  select.multiple = multiple

  options.forEach(({ label, value }) => {
    const option = createElement("option", { text: label })
    option.value = value
    select.appendChild(option)
  })

  return select
}

export const createSummary = (title, value) => {
  const summary = document.createDocumentFragment()
  summary.append(`${title}: `, createElement("strong", { text: value }))

  return summary
}
